import { createFileRoute } from '@tanstack/react-router'
import DashboardPage from '@/spa/pages/DashboardPage'
import { routeErrorComponent } from './_shared/RouteError'

export const Route = createFileRoute('/dashboard')({
  component: DashboardPage,
  errorComponent: routeErrorComponent,
})
